<plyca-ui-comparator [config]="{}" class="comparator-panel">
  <div class="card-container">
    @if (comparatorDataSig()?.content?.length > 0) {
      @for (item of comparatorDataSig().content; track item.name; let isLast = $last) {
        <div class="card-item">
          <div class="button-delete">
            <plyca-ui-button-generic
              [config]="{
                buttonClass: 'btn btn-xs btn-secondary',
                type: 'button'
              }"
              (clickEvent)="onClickDelete(item)"
            >
              <span><i class="fa fa-times" aria-hidden="true"></i> {{ 'Delete' }} </span>
            </plyca-ui-button-generic>
          </div>
          <br />
          <div class="properties">
            @if (item.materialImage) {
              <p class="image">
                <img src="{{ item.materialImage }}" alt="image-product" class="image" />
              </p>
            }
            @if (item.identifier) {
              <span class="label">{{ 'Reference' }}</span>
              <p>{{ item.identifier }}</p>
            }
            @if (item.name) {
              <span class="label">{{ 'Name' }}</span>
              <p>{{ item.name }}</p>
            }
            <div class="buttons-container-add">
              <plyca-ui-button-generic
                [config]="{
                  buttonClass: 'btn btn-xs btn-primary button-add-to-cart',
                  type: 'button'
                }"
                (clickEvent)="onClickAdd(item)"
              >
                <span> <i class="fa fa-plus" aria-hidden="true"></i> {{ 'Add' }} </span>
              </plyca-ui-button-generic>
            </div>
          </div>
        </div>
        @if (!isLast) {
          <plyca-ui-divider [config]="{ layout: 'vertical' }" />
        }
      }
    } @else {
      <div class="not-found">
        {{ 'Results not found' }}
      </div>
    }
  </div>
</plyca-ui-comparator>
